import i18n from '../locales/i18n'
import moment from '../momentLocale'
import DateFormat from './dateFormat'

export const REQUIRED_PASSWORD_LENGTH = 12
export const DATE_FORMAT = moment.localeData().longDateFormat('L')
export const HOURS_FORMAT = moment
  .localeData()
  // @ts-ignore
  .longDateFormat(DateFormat.TIME_WITH_MERIDIAN)
export const ZENDESK_SCRIPT_URL =
  'https://static.zdassets.com/ekr/snippet.js?key=93a418e2-5aac-48ad-b257-9b81506f1c02'
export const DEBOUNCE_ACTION_TIME = 1000
export const INFINITE_LIST_BATCH_LOAD_COUNT = 25
export const FINITE_LIST_LOAD_COUNT = 1000
export const CLIENTS_BATCH_LOAD_COUNT = 10
export const PROBLEMS_HISTORY_LOAD_COUNT = 10
export const CONVERSATIONS_BATCH_LOAD_COUNT = 20
export const CONVERSATION_MESSAGES_BATCH_LOAD_COUNT = 20
export const SEARCH_BATCH_LOAD_COUNT = 20
export const BSA_ARTICLE_URL =
  'https://www.avma.org/News/Journals/Collections/Documents/javma_225_5_689.pdf'
export const NIH_URL =
  'https://dailymed.nlm.nih.gov/dailymed/search.cfm?labeltype=all&query='
export const CUSTOM_COMPOUND_ID = 'CUSTOM_COMPOUND_ID'
export const MIN_SEARCH_LENGTH = 2
export const MIN_PROBLEMS_WIDGET_SEARCH_LENGTH = 3
export const CLIENTS_SEARCH_LENGTH = 2
export const SCHEDULE_TOOLTIP_DELAY = 1200
export const RESEND_INVITATION_MAX_TIMES = 5
export const DEFAULT_RESPONSE_ERROR_MESSAGE = 'Network Error'
export const SENTRY_DNS =
  'https://cb736ac345044e62938ab58df4973579@sentry.io/1804382'
export const SUPPORT_EMAIL = 'support@rhapsody.vet'
export const UNASSIGNED_PLACEHOLDER = i18n.t('Common:UNASSIGNED')
export const DEFAULT_DUE_DATE_UNIT = 'YEARS'
export const DEFAULT_DUE_DATE_AMOUNT = 1
export const DEBOUNCE_TRANSACTION_CHECK_TIME = 10000
export const SUPPORT_URL = 'https://help.rhapsody.vet/'
export const DEFAULT_UPDATE_INTERVAL = 1000
export const STATUS_UPDATE_INTERVAL = 10 * 60 * 1000
export const BALANCE_PAGE_UPDATE_INTERVAL = 10 * 1000
export const LAB_ORDERS_UPDATE_INTERVAL = 60 * 1000
export const CONVERSATION_MESSAGES_UPDATE_INTERVAL = 5000
export const COOKIE_TTL = 60 * 60 * 24 * 7
export const REFRESH_INTERVAL = 30000
export const NOTES_TEMPLATE_DEBOUNCE_UPDATE = 300
export const COPY_TO_CLIPBOARD_TOOLTIP_HIDING_DELAY = 3000
export const MIN_ESTIMATES_TO_LOAD = 5
export const MAX_ESTIMATES_TO_LOAD = 20
